import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs as defaultFaqs } from '../data/mock';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FAQ = () => {
  const [faqs, setFaqs] = useState(defaultFaqs);
  const [header, setHeader] = useState({
    label: "FAQ",
    title: "Frequently Asked Questions",
    description: "Find answers to common questions about our services and approach"
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [faqsRes, headerRes] = await Promise.all([
          axios.get(`${API}/content/faq`),
          axios.get(`${API}/content/section-headers/faq`)
        ]);
        if (faqsRes.data && faqsRes.data.length > 0) {
          setFaqs(faqsRes.data.filter(item => item.visible !== false));
        }
        if (headerRes.data) {
          setHeader(headerRes.data);
        }
      } catch (error) {
        console.log('Using default FAQs');
      }
    };
    fetchData();
  }, []);

  return (
    <section id="faq" className="py-8 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <span className="inline-block text-gold-600 font-semibold text-sm tracking-wider uppercase mb-4">
            {header.label}
          </span>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-navy-900 mb-6">
            {header.title}
          </h2>
          <p className="text-base text-gray-600 leading-relaxed">
            {header.description}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="panel-flair bg-white rounded-xl border-2 border-slate-200/70 hover:border-gold-400 px-6 overflow-hidden shadow-sm transition-all"
            >
              <AccordionTrigger className="text-left text-navy-900 font-semibold py-6 hover:no-underline hover:text-gold-600 transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
